export default "__VITE_ASSET__PkhRavBi__"